function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  rx: 13,
  fill: "#FEF0E3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_55237_50538)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7012 5.7364C12.8889 5.64255 13.1098 5.64255 13.2975 5.7364L19.9642 9.06973C20.19 9.18266 20.3327 9.4135 20.3327 9.66602C20.3327 9.91853 20.19 10.1494 19.9642 10.2623L13.2975 13.5956C13.1098 13.6895 12.8889 13.6895 12.7012 13.5956L6.03454 10.2623C5.80868 10.1494 5.66602 9.91853 5.66602 9.66602C5.66602 9.4135 5.80868 9.18266 6.03454 9.06973L12.7012 5.7364ZM7.82339 9.66602L12.9993 12.254L18.1753 9.66602L12.9993 7.07804L7.82339 9.66602Z",
  fill: "#F47F4D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.73654 16.0347C5.9012 15.7054 6.30165 15.5719 6.63097 15.7365L12.9995 18.9208L19.368 15.7365C19.6973 15.5719 20.0978 15.7054 20.2624 16.0347C20.4271 16.364 20.2936 16.7645 19.9643 16.9291L13.2976 20.2624C13.11 20.3563 12.889 20.3563 12.7014 20.2624L6.03469 16.9291C5.70537 16.7645 5.57188 16.364 5.73654 16.0347Z",
  fill: "#F47F4D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.73654 12.7027C5.9012 12.3733 6.30165 12.2399 6.63097 12.4045L12.9995 15.5888L19.368 12.4045C19.6973 12.2399 20.0978 12.3733 20.2624 12.7027C20.4271 13.032 20.2936 13.4324 19.9643 13.5971L13.2976 16.9304C13.11 17.0243 12.889 17.0243 12.7014 16.9304L6.03469 13.5971C5.70537 13.4324 5.57188 13.032 5.73654 12.7027Z",
  fill: "#F47F4D"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_55237_50538"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(5 5)"
})));

var SvgSeason = function SvgSeason(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeason, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/season.a8810c87.svg";
export { ForwardRef as ReactComponent };